import { put, call, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/transactions";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg } from "../../utils/Helpers";

function* transactionsListSaga({ payload }) {
  try {
    const response = yield call(apis.transactionsList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.transactionsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.transactionsListRequest({
          ...payload,
          page: +response.headers["total-pages"]
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* TransactionsSaga() {
  yield takeLatest(
    types.TRANSACTIONS_LIST_REQUEST,
    transactionsListSaga
  );
}
